








import { Component, Prop, Vue } from "vue-property-decorator";
import FullCalendar from "@fullcalendar/vue";

@Component({
  name: "AgendaCalendarView",
  components: { FullCalendar },
})
export default class AgendaCalendarView extends Vue {
  @Prop({ required: true }) public calendarOptions!: any;
  @Prop({ default: false }) public hasBandeja!: boolean;

  public getCalendarApi(): any {
    const ref = this.$refs.calRef as any;
    return ref && ref.getApi ? ref.getApi() : null;
  }
}
